<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Attach resource pool') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ _('Filter the search') }}</label>
            <input type="text" class="form-control" v-model="searchFilter" />
          </div>
        </div>
      </div>
      <div style="height: 350px; overflow-y: auto; overflow-x: hidden">
        <table class="table table-striped">
          <tbody>
            <tr v-for="pool in filteredResourcepools" v-on:click="toggleResourcepool(pool)">
              <td style="width: 50px">
                {{ pool.id }}
              </td>
              <td>
                <strong>{{ pool.name }}</strong>
              </td>
              <td style="width: 50px">
                <button type="button" :class="btnClass(pool)" v-on:click.stop="toggleResourcepool(pool)"><i :class="'fa fa-fw fa-' + btnIcon(pool)"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selectResourcepool" :disabled="!canSelect"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'
import formatters from '~/lib/formatters'

export default {
  props: ['selectedResourcepools'],
  mixins: [constants, formatters],
  data () {
    return {
      resourcepool: null,
      resourcepools: [],
      addResourcepoolIds: [],
      searchFilter: ''
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey']),
    selectedResourcepoolIds () {
      return this.selectedResourcepools.map(l => l.id)
    },
    filteredResourcepools () {
      if (!this.searchFilter) {
        return this.resourcepools
      }
      return this.resourcepools.filter(r => this.addResourcepoolIds.includes(r.id) || String(r.id) === this.searchFilter || r.name.toLowerCase().includes(this.searchFilter.toLowerCase()))
    },
    canSelect () {
      return this.addResourcepoolIds && this.addResourcepoolIds.length
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selectResourcepool () {
      this.$emit('selectResourcepools', this.resourcepools.filter(r => this.addResourcepoolIds.includes(r.id)))
    },
    async loadResourcepools() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/resourcepools.json?iSortingCols=1&iSortCol_0=1&sSortDir_0=asc&apikey=' + this.apiKey)
      } catch(e) {}
      this.resourcepools = response.data.filter(resourcepool => {
        return this.selectedResourcepoolIds.indexOf(resourcepool.id) === -1 // Only list resources that are not already added
      })
    },
    btnClass (resourcepool) {
      if (this.addResourcepoolIds.includes(resourcepool.id)) {
        return 'btn btn-xs btn-success'
      }
      return 'btn btn-xs btn-default'
    },
    btnIcon (resourcepool) {
      if (this.addResourcepoolIds.includes(resourcepool.id)) {
        return 'check-square'
      }
      return 'check-square-o'
    },
    toggleResourcepool(resourcepool) {
      if (this.addResourcepoolIds.includes(resourcepool.id)) {
        this.addResourcepoolIds = this.addResourcepoolIds.filter(id => id !== resourcepool.id)
      } else {
        this.addResourcepoolIds.push(resourcepool.id)
      }
    }
  },
  mounted () {
    this.loadResourcepools()
  }
}
</script>